import { useAppTranslations } from '../../hooks';
import './ForbiddenPage.scss';

const namespace = 'forbidden-page';

export const ForbiddenPage: React.FC = () => {
  const { FORBIDDEN_RESOURCE } = useAppTranslations();

  return (
    <>
      <div className={`${namespace}__container`}>
        <strong>{FORBIDDEN_RESOURCE}</strong>
      </div>
    </>
  );
};
